import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { getSpareDefaultImage } from 'shared/constants/defaultImages';
import AdvertCard from 'desktop/components/AdvertCard/AdvertCard';
import Carousel from 'desktop/components/Carousel/Carousel';
import s from './AnotherSpares.css';

const IMAGE_WIDTH = 173;
class AnotherSpares extends React.Component {
  static propTypes = {
    spares: PropTypes.arrayOf(PropTypes.shape()),
    title: PropTypes.string.isRequired,
  };
  static defaultProps = {
    spares: [],
  };

  generateLink = slug => `/zapchasti/${slug}`.replace(/\/\//g, '/');

  render() {
    const { spares, title } = this.props;
    const imageStyles = { height: '150px' };

    if (!(spares && spares.length)) {
      return null;
    }

    const transformedSpares = spares.map(({ year_from: from, year_to: to, make, ...props }) => ({
      ...props,
      make: { title: props.title },
      model: {},
      year: from === to ? from : `${from || ''}${from && to ? ' - ' : ''}${to || ''}`,
    }));

    return (
      <div className={s.root}>
        <Carousel
          step={4}
          itemsInRow={4}
          loop
          classNames={{
            header: s.header,
            body: s.carouselBody,
          }}
          header={
            <div className={s.title}>
              {title}
            </div>
          }
          items={transformedSpares.map(spare =>
            <AdvertCard
              defaultImage={getSpareDefaultImage()}
              link={spare.permalink || this.generateLink(spare.id)}
              key={spare.id}
              item={spare}
              imageStyle={imageStyles}
              advertClassName={s.advertItem}
              cardType="similar"
              width={IMAGE_WIDTH}
            />,
          )}
        />
      </div>
    );
  }
}

export default withStyles(s)(AnotherSpares);



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/components/AnotherSpares/AnotherSpares.js